import React, { useEffect, useState, useContext } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import { Documents } from ".";
import { useParams } from "react-router-dom";

type ISeries = {
  name: string;
  data: number[];
}[];

export const ChartBar = ({ data }: Documents) => {
  const {
    getSizesComponent,
    setFontSize,
    componentProperty,
    generateRedirectUrl,
  } = useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(380);
  const [widthChart, setWidthChart] = useState(300);
  const [categories, setCategories] = useState<string[]>([]);
  const [series, setSeries] = useState<ISeries>([]);
  const { mode } = useParams();

  useEffect(() => {
    data.documents.map((element, key) => {
      if (element.courier === null) {
        data.documents[key].courier = "SEM TRANSPORTADORA";
      }
    });
    if (data && data.documents) {
      const series: ISeries = [
        {
          name: "Sem Rota",
          data: data.documents.map((element) => Number(element.pending)),
        },
        {
          name: "Em Trânsito",
          data: data.documents.map((element) => Number(element.in_route)),
        },
        {
          name: "Não entregues",
          data: data.documents.map((element) => Number(element.not_delivered)),
        },
        {
          name: "Finalizados APP",
          data: data.documents.map(
            (element) =>
              Number(element.finished) - Number(element.finished_console)
          ),
        },
        {
          name: "Finalizados Console",
          data: data.documents.map((element) =>
            Number(element.finished_console)
          ),
        },
      ];

      setSeries(series);
      setCategories(data.documents.map((element) => element.courier));
    }

    const sizes = getSizesComponent({ id: "chart-adoption-rate-courier" });
    if (sizes.width < 345) {
      setFontSize({ id: "chart-adoption-rate-courier", width: sizes.width });
    }
    setHeightChart(sizes.height - 40);
    setWidthChart(sizes.width);
    setCompleteRequisition(true);
  }, [data]);

  const options: ApexOptions = {
    chart: {
      type: "bar",
      height: 350,
      stacked: true,
      toolbar: {
        show: false,
      },
      events: {
        dataPointSelection: async (event, chartContext, config) => {
          let selected =
            data.documents[config.dataPointIndex].courier_cnpj ?? "";

          if (selected === "SEM TRANSPORTADORA") {
            selected = "null";
          }
          const type = config.seriesIndex;
          let status: number[] = [];
          let justification = "";

          switch (type) {
            case 0:
              status = [12, 15, 20];
              break;

            case 1:
              status = [0, 1, 2, 5, 7, 10, 11, 16, 18];
              break;

            case 2:
              status = [6, 9];
              break;

            case 3:
              status = [3, 4, 8, 13, 17];
              break;

            case 4:
              status = [3, 4, 8, 13, 17];
              justification = "Ajuste manual";
              break;

            default:
              break;
          }

          if (
            mode === "view" &&
            componentProperty({
              id: "chartAdoptionRateCourier",
              property: "redirect",
            })
          ) {
            window.open(
              await generateRedirectUrl("chartAdoptionRateCourier", {
                redirectTowerToIndex: true,
                date: true,
                eDate: true,
                status_stop_id: status,
                cnpj_carrier: selected,
                justification,
              }),
              "_blank"
            );
          }
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          total: {
            enabled: true,
            offsetX: 0,
            style: {
              fontSize: "13px",
              fontWeight: 900,
            },
          },
        },
      },
    },
    stroke: {
      width: 1,
      colors: ["#989898", "#F9AA00", "#E16363", "#5ABF3B", "#419C25"],
    },
    colors: ["#989898", "#F9AA00", "#E16363", "#5ABF3B", "#419C25"],
    xaxis: {
      categories: categories,
    },
    yaxis: {
      title: {
        text: undefined,
      },
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    fill: {
      opacity: 1,
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
      offsetX: 40,
    },
  };

  return completeRequisition ? (
    <div className="h100">
      <HeaderComponent
        title={`Adesão por Transportadora`}
        clickable={componentProperty({
          id: "chartAdoptionRateCourier",
          property: "redirect",
        })}
        id="chart-adoption-rate-courier"
      />
      <div
        id={
          categories.length < 10 ||
          getSizesComponent({ id: "chart-adoption-rate-courier" }).height >
            categories.length * 183
            ? "fixedBox"
            : "scrollBox"
        }
      >
        <div id="chart">
          <Chart
            type="bar"
            options={options}
            series={series}
            height={heightChart}
            width={widthChart}
          />
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};
